import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { errorMessage } from '../lib/errors';

export function UnauthorizedPage() {
  const { user, signOut } = useAuth();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const onSignOut = async () => {
    setBusy(true);
    setError(null);
    try {
      await signOut();
      navigate('/login', { replace: true });
    } catch (e) {
      setError(errorMessage(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-[var(--paz-vh,100vh)] items-center justify-center bg-bg px-4">
      <div className="w-full max-w-sm text-center">
        <h1 className="text-4xl font-semibold text-text">403</h1>
        <p className="mt-2 text-sm text-text-muted">
          {user?.email ? (
            <>
              <span className="font-medium text-text">{user.email}</span> does not have access to the On-Site Portal. It is available to PazNetworks staff and assigned technicians.
            </>
          ) : (
            'This account does not have access to the On-Site Portal.'
          )}
        </p>
        {error && (
          <p role="alert" className="mt-3 text-sm text-error">
            Sign-out failed: {error}
          </p>
        )}
        <button type="button" onClick={() => void onSignOut()} disabled={busy} className="btn-primary mt-5 w-full">
          {busy ? 'Signing out…' : 'Sign out and use a different account'}
        </button>
      </div>
    </div>
  );
}
